import React from 'react';

import type { IconProps } from '@/core/components/Icons/Icons';

const LogOut: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M15 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H15M26.6667 28.3334L35.0001 20.0001M35.0001 20.0001L26.6667 11.6667M35.0001 20.0001L15 20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogOut;
